<template lang="pug">
  dv-text-field(
    v-maska:[extraMaskaOptions]
    v-bind="$attrs"
    :value="outputValue"
    @blur="onBlur"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")
</template>

<script>
import { vMaska } from 'maska';
import DvTextField from './DvTextField.vue';

const DEFAULT_MASKA_OPTIONS = {
  mask: undefined,
  eager: false,
  tokens: {},
  tokensReplace: {},
  reversed: false,
  preProcess: (v) => v,
  postProcess: (v) => v,
  serializer: (v) => v,
  returnMasked: false,
};

export default {
  directives: {
    maska: vMaska,
  },
  components: {
    DvTextField,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    maskaOptions: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    return {
      outputValue: this.value,
    };
  },
  watch: {
    value(value) {
      this.outputValue = value;
    },
  },
  computed: {
    extraMaskaOptions() {
      const maskaOptions = {
        ...DEFAULT_MASKA_OPTIONS,
        ...this.maskaOptions,
      };
      const { returnMasked, postProcess } = maskaOptions;

      return {
        onMaska: ({ masked, unmasked }) => {
          const outputValue = returnMasked ? masked : unmasked;

          this.outputValue = postProcess(outputValue);
        },
        ...maskaOptions,
      };
    },
    serializedValue() {
      const { outputValue } = this;
      const { serializer } = this.extraMaskaOptions;

      return serializer(outputValue);
    },
  },
  methods: {
    onBlur() {
      this.$emit('input', this.serializedValue);
      this.outputValue = this.serializedValue;
    },
  },
};
</script>
